import axios from "axios";
import {Button, Modal} from "reactstrap";
import { useTranslation } from 'react-i18next';

const FileModal = (props) => {
    const { t, i18n } = useTranslation();
    console.log(props.data)

    return (
        <Modal
            className="modal-dialog-centered"
            isOpen={props.isOpen}
        >
            <div className="modal-header">
                <h5 className="modal-title" id="exampleModalLabel">
                    Modal title
                </h5>
                <button
                    aria-label="Close"
                    className="close"
                    data-dismiss="modal"
                    type="button"
                    onClick={() => props.onRequestClose()}
                >
                    <span aria-hidden={true}>×</span>
                </button>
            </div>
            <div className="modal-body">
                {
                    props.data == null || props.data.length === 0 ? ('files not fount') : (<ul>
                        {props.data.map((item, index) => (
                            <li key={index}>
                                <a href={item.file} target="_blank" rel="noopener noreferrer">
                                    {item.file}
                                </a>

                            </li>
                        ))}
                        </ul>
                    )}
            </div>
            <div className="modal-footer">
                <Button
                    color="secondary"
                    data-dismiss="modal"
                    type="button"
                    onClick={() => props.onRequestClose()}
                >
                    {t('Close')}
                </Button>
                <Button color="primary" type="button">
                    {t('Save')}
                </Button>
            </div>
        </Modal>
    )
}

export default FileModal


